import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { WEBHOOK_SETTINGS_API } from '../api/webhooks-api'
import {
  WebhookCreateInterface,
  WebhookErrorInterface,
  WebhookId,
  WebhookInterface,
  WebhookUpdateInterface,
} from '../types/webhook-settings-interface'

export const useWebhookSettingsApi = () => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum, WebhookInterface>({
    method: RequestMethodsEnum.post,
  })

  const { fetcher: patchFetcher } = useFetch<
    RequestMethodsEnum,
    WebhookInterface,
    any,
    WebhookErrorInterface
  >({
    method: RequestMethodsEnum.patch,
  })

  const { fetcher: deleteFetcher } = useFetch<RequestMethodsEnum>({
    method: RequestMethodsEnum.delete,
  })

  const create = (body: WebhookCreateInterface) => postFetcher(WEBHOOK_SETTINGS_API, body)

  const remove = (id: WebhookId) => deleteFetcher(`${WEBHOOK_SETTINGS_API}/${id}`)

  const edit = (id: WebhookId, body: WebhookUpdateInterface) =>
    patchFetcher(`${WEBHOOK_SETTINGS_API}/${id}`, body, {
      headers: { 'Content-Type': 'application/merge-patch+json' },
    })

  return { create, remove, edit }
}
